import TypeAhead from './TypeAhead/SearchBar';
import SearchBarParams from './TypeAhead/SearchBar.Params';
import  SearchResults from './SearchResults/SearchResults';
import SearchResultsParams from "./SearchResults/SearchResults.Params";
import  Listing from './Listing/Listing';
import ListingParams from "./Listing/Listing.Params";


const WidgetNames = Object.freeze({
  searchResults: "searchResults",
  typeAhead: "typeAhead",
  typeAheadMobile: "typeAheadMobile",
  listing: "listing"
});

const Widget = ({ content, children }) => {
  switch (content) {
    case WidgetNames.searchResults:
      return <SearchResults>{children}</SearchResults>;
      // return <>{children}</>;
    case WidgetNames.typeAhead:
      return <TypeAhead>{children}</TypeAhead>;
    case WidgetNames.typeAheadMobile:
      return <TypeAhead>{children}</TypeAhead>;
      // return <>{children}</>;
    case WidgetNames.listing:
      return <Listing>{children}</Listing>;
    default:
      return <>{children}</>;
  }
};

const WidgetParams = (content, params) => {
  switch (content) {
    case WidgetNames.searchResults:
      return new SearchResultsParams(params);
    case WidgetNames.typeAhead:
      return new SearchBarParams(params);
    case WidgetNames.typeAheadMobile:
      return new SearchBarParams(params);
    case WidgetNames.listing:
      return new ListingParams(params);
    default:
      return params;
  }
};

export { WidgetNames, Widget, WidgetParams };
